export * from './BaseActions.vue';
export { default } from './BaseActions.vue';
